import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "data-item__section article__images" };
const _hoisted_2 = { for: "image-file-input" };
const _hoisted_3 = { class: "article__upload-info" };
const _hoisted_4 = {
    key: 0,
    class: "article__upload-indicator"
};
const _hoisted_5 = {
    key: 0,
    class: "article__upload-indicator-inner"
};
const _hoisted_6 = {
    key: 1,
    class: "article__upload-indicator-inner"
};
import { ref } from "vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import { bytesFilter } from "@/Filters";
const maxFileSize = (10 * 1000 * 1000); // 10 MB
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoDeliveryImageZone',
    props: {
        upload: { type: Function },
        uploadDisabled: { type: Boolean },
        uploadVisible: { type: Boolean }
    },
    setup(__props) {
        const file = ref(null);
        const props = __props;
        const dragging = ref(false);
        const uploads = ref(0);
        function onFileDrop(e) {
            if (props.uploadDisabled) {
                alerts.warning(trans('upload.drop_disabled'), undefined, { timeout: 5000 });
                dragging.value = false;
                return;
            }
            const dataTransfer = e.dataTransfer;
            if (!dataTransfer || dataTransfer.files.length === 0) {
                e.preventDefault();
                dragging.value = false;
                return;
            }
            let hasInvalidFiles = false;
            let hasOversizedFiles = false;
            const toUpload = [];
            for (let i = 0; i < dataTransfer.files.length; i++) {
                const file = dataTransfer.files.item(i);
                if (!file) {
                    continue;
                }
                if (file.size > maxFileSize) {
                    hasOversizedFiles = true;
                }
                else if (file.type.indexOf('image/') !== 0) {
                    hasInvalidFiles = true;
                }
                else {
                    toUpload.push(file);
                }
            }
            if (hasInvalidFiles) {
                alerts.warning(trans('upload.only_images_allowed'), undefined, { timeout: 5000 });
            }
            if (hasOversizedFiles) {
                alerts.warning(trans('upload.max_file_size_exceeded', { max: bytesFilter(maxFileSize) }), undefined, { timeout: 5000 });
            }
            dragging.value = false;
            toUpload.forEach(uploadFile);
        }
        function startUpload() {
            const fileInput = file.value;
            const files = fileInput.files;
            let hasInvalidFiles = false;
            let hasOversizedFiles = false;
            for (let i = 0; i < files.length; i++) {
                const file = files.item(i);
                if (file.size > maxFileSize) {
                    hasOversizedFiles = true;
                }
                else if (file.type.indexOf('image/') !== 0) {
                    hasInvalidFiles = true;
                }
                else {
                    uploadFile(file);
                }
            }
            if (hasInvalidFiles) {
                alerts.warning(trans('upload.only_images_allowed'), undefined, { timeout: 5000 });
            }
            if (hasOversizedFiles) {
                alerts.warning(trans('upload.max_file_size_exceeded', { max: bytesFilter(maxFileSize) }), undefined, { timeout: 5000 });
            }
            fileInput.value = "";
        }
        function uploadFile(file) {
            uploads.value += 1;
            props.upload(file)
                .finally(() => uploads.value -= 1);
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["data-item__content article__images-wrapper", { 'article__images-wrapper--dragging': dragging.value }]),
                onDrop: _withModifiers(onFileDrop, ["prevent"]),
                onDragenter: _cache[0] || (_cache[0] = _withModifiers(($event) => (dragging.value = true), ["prevent"])),
                onDragleave: _cache[1] || (_cache[1] = _withModifiers(($event) => (dragging.value = false), ["prevent"])),
                onDragover: _cache[2] || (_cache[2] = _withModifiers(($event) => (dragging.value = true), ["prevent"]))
            }, [
                _renderSlot(_ctx.$slots, "before"),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("section", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "images"),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uploads.value, (index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "article__upload"
                        }, [
                            _createVNode(Spinner, { loading: true })
                        ]));
                    }), 128)),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    (props.uploadDisabled !== true && props.uploadVisible !== false)
                        ? (_openBlock(), _createElementBlock("form", {
                            key: 0,
                            class: "article__upload article__upload--new",
                            onSubmit: _withModifiers(startUpload, ["prevent"])
                        }, [
                            _createElementVNode("input", {
                                type: "file",
                                onChange: startUpload,
                                ref_key: "file",
                                ref: file,
                                id: "image-file-input",
                                accept: "image/*",
                                multiple: ""
                            }, null, 544),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("label", _hoisted_2, [
                                _createVNode(_component_icon, { name: "upload" }),
                                _cache[3] || (_cache[3] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('upload.info', { max: _unref(bytesFilter)(maxFileSize) })), 1)
                            ])
                        ], 32))
                        : _createCommentVNode("", true)
                ]),
                _cache[9] || (_cache[9] = _createTextVNode()),
                _renderSlot(_ctx.$slots, "after"),
                _cache[10] || (_cache[10] = _createTextVNode()),
                (props.uploadVisible !== false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (props.uploadDisabled !== true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('upload.drop_instruction')), 1))
                            : _createCommentVNode("", true),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        (props.uploadDisabled === true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('upload.drop_disabled')), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ], 34));
        };
    }
});
